export default __webpack_public_path__ + "static/media/music_glass_new.f07806cd.mp3";